<article itemtype="https://schema.org/NewsArticle">
  <meta property="datePublished" [content]="date" />
  <div class="innerContainer edito__breadcrumb">
    <vc-breadcrumb [items]="pageBreadcrumb" [isCatalogPage]="false"></vc-breadcrumb>
  </div>
  <vc-page
    *ngIf="userData"
    pageType="edito"
    [userData]="userData"
    [isMdUp]="isMdUp"
    [overwrightPage]="editoPageFromResolver"
    (blockList$)="parseBlockList($event)"
    [updatedBlockList]="updatedBlockList"
    [pageParam]="pageParam"
    (onTrackClick)="onTrackClick($event)"
    (onTrackView)="onTrackView($event)"
  >
    <vc-catalog
      *ngIf="configCatalogArray[0]"
      [config]="configCatalogArray[0]"
      [likedItem]="likedItem"
      pageType="landing"
      catalog-product-one
    ></vc-catalog>
    <vc-catalog
      *ngIf="configCatalogArray[1]"
      [config]="configCatalogArray[1]"
      [likedItem]="likedItem"
      pageType="landing"
      catalog-product-two
    ></vc-catalog>
    <vc-catalog
      *ngIf="configCatalogArray[2]"
      [config]="configCatalogArray[2]"
      [likedItem]="likedItem"
      pageType="landing"
      catalog-product-three
    ></vc-catalog>
    <vc-catalog
      *ngIf="configCatalogArray[3]"
      [config]="configCatalogArray[3]"
      [likedItem]="likedItem"
      pageType="landing"
      catalog-product-four
    ></vc-catalog>
    <vc-catalog
      *ngIf="configCatalogArray[4]"
      [config]="configCatalogArray[4]"
      [likedItem]="likedItem"
      pageType="landing"
      catalog-product-five
    ></vc-catalog>
    <vc-catalog
      *ngIf="configCatalogArray[5]"
      [config]="configCatalogArray[5]"
      [likedItem]="likedItem"
      pageType="landing"
      catalog-product-six
    ></vc-catalog>
  </vc-page>
</article>
<section
  *ngIf="platformService.isBrowser && editoPageFromResolver?.legacyEditoID && commentsBlock$ | async as comments"
  class="vc-section edito__comments"
>
  <div class="innerContainer">
    <h3 *ngIf="comments?.body?.title; else phraseappTitle" class="vc-title-s edito__comments-title">
      {{ comments.body.title }}
    </h3>
    <vc-discussions
      [commentType]="'edito'"
      [editoId]="editoPageFromResolver.legacyEditoID"
      [showLikeFunctionality]="false"
    ></vc-discussions>
  </div>
</section>

<ng-template #phraseappTitle>
  <h3 class="vc-title-s edito__comments-title" i18n="@@EDITO.COMMENTS.TITLE">Comments</h3>
</ng-template>
